export const hasPermissions = (route, entities) => {
  return process.env.VUE_APP_DEV ? true : entities.includes(route)
}
